import { useCallback, useEffect, useState } from 'react';
import { api } from '../api';

export interface CourseProgress {
  totalModules: number;
  completedModules: number;
  progressPercentage: number;
  timeSpentSeconds: number;
  lastAccessed: string | null;
  addedSeconds?: number;
}

/**
 * Récupère la progression de l'apprenant courant sur un cours
 * (sprint « traçabilité apprenants » — 01/10/2026).
 * Endpoint : GET /api/Student/Student/courses/:id/progress
 */
export const useCourseProgress = (courseId?: string, enabled: boolean = true) => {
  const [progress, setProgress] = useState<CourseProgress | null>(null);
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async (): Promise<CourseProgress | null> => {
    if (!courseId) return null;
    try {
      setLoading(true);
      const response = await api.get(`/Student/Student/courses/${courseId}/progress`);
      const data = response.data as CourseProgress;
      setProgress(data);
      return data;
    } catch (error) {
      console.error('Error loading course progress:', error);
      return null;
    } finally {
      setLoading(false);
    }
  }, [courseId]);

  useEffect(() => {
    if (courseId && enabled) {
      reload();
    }
  }, [courseId, enabled, reload]);

  return { progress, loading, reload, setProgress };
};

export default useCourseProgress;
